import { StarFilledIcon, StarIcon } from "@repo/edtech-assets";
import clsx from "clsx";

import st from "./StarsRating.module.scss";

type Props = {
  maxRating: number,
  activeStar: number | null,
  onStarClick: (value: number) => void,
  onHoverChange: (num: number | null) => void,
  isMobile: boolean,
  iconClassName?: string,
  wrapClassName?: string,
};

export const StarsRating = ({
  maxRating,
  activeStar,
  onStarClick,
  onHoverChange,
  isMobile,
  iconClassName = "",
  wrapClassName = "",
}: Props) => {
  return (
    <div
      className={
        clsx(
          st.stars, maxRating > 10 && st.rows, wrapClassName,
        )
      }
    >
      {
        Array.from({
          length: maxRating,
        }, (_, i) => i + 1).map((num) => (
          <button
            key={num}
            className={st.button}
            onClick={() => onStarClick(num)}
            onMouseLeave={!isMobile ? () => onHoverChange(null) : undefined}
            onMouseMove={!isMobile ? () => onHoverChange(num) : undefined}
            onTouchEnd={isMobile ? () => onHoverChange(null) : undefined}
            onTouchStart={isMobile ? () => onHoverChange(num) : undefined}
          >
            {
              num <= (activeStar || 0) ? (
                <StarFilledIcon
                  className={
                    clsx(
                      st.icon, iconClassName, st.selected,
                    )
                  }
                />
              ) : (
                <StarIcon className={clsx(st.icon, iconClassName)} />
              )
            }
          </button>
        ))
      }
    </div>
  );
};
